import { About } from "../About/About";
import { API } from "../api/Api";
import { bridgeConstants } from "../api/Bridges";
import { genericEntityConstants } from "../api/GenericConstants";
import { iconNMRConstants } from "../api/IconNMR";
import {
  AnnouncementAddFormPage,
  AnnouncementCloneFormPage,
  AnnouncementDetailsPage,
  AnnouncementEditFormPage,
  AnnouncementsTablePage,
} from "../Announcements/AnnouncementViews";
import { AttachmentDetailsPage, AttachmentEditFormPage, AttachmentsTablePage } from "../Attachments/AttachmentViews";
import { AuditLogDetailsPage, AuditLogsTablePage } from "../AuditLog/AuditLogViews";
import { BridgeClientWizard } from "../Autoloads/Wizard/BridgeClientWizard";
import { SFTPBridgeClientWizard } from "../Autoloads/Wizard/SFTPBridgeClientWizard";
import {
  BridgeCloneFormPage,
  BridgeDetailsPage,
  BridgeEditFormPage,
  BridgesTablePage,
} from "../Autoloads/Bridges/BridgeViews";
import {
  DataSourceAddFormPage,
  DataSourceCloneFormPage,
  DataSourceDetailsPage,
  DataSourceEditFormPage,
  DataSourceTablePage,
} from "../Autoloads/DataSources/DataSourceViews";
import {
  IconNMRDataSourceAddFormPage,
  IconNMRDataSourceCloneFormPage,
  IconNMRDataSourceDetailsPage,
  IconNMRDataSourceEditFormPage,
} from "../Autoloads/IconNMR/IconNMRViews";
import { ComponentOverview } from "../common/components/ComponentOverview";
import { SessionContext } from "../common/contexts/SessionContext";
import { useFeatureFlag } from "../common/contexts/UseFeatureFlags";
import {
  CustomFieldAddFormPage,
  CustomFieldCloneFormPage,
  CustomFieldDetailsPage,
  CustomFieldEditFormPage,
  CustomFieldsTablePage,
} from "../Customization/CustomFields/CustomFieldViews";
import {
  CustomTypeAddFormPage,
  CustomTypeCloneFormPage,
  CustomTypeDetailsPage,
  CustomTypeEditFormPage,
  CustomTypesTablePage,
} from "../Customization/CustomTypes/CustomTypeViews";
import {
  DatasetAddForm,
  DatasetClaimFormPage,
  DatasetDetailsPage,
  DatasetEditFormPage,
  DatasetsTablePage,
} from "../Dataset/DatasetViews";
import { DatasetsBulkEditTable } from "../Dataset/Table/DatasetsBulkEditTable";
import { Dashboard } from "../Dashboard/Dashboard";
import { IconNMR } from "../IconNMR/IconNMR";
import {
  InventoriesTablePage,
  InventoryDetailsRedirect,
  InventoryItemAddFormPage,
  InventoryItemCloneFormPage,
  InventoryItemDetailsPage,
  InventoryItemEditFormPage,
  InventoryItemsTablePage,
  InventoryItemTreePage,
} from "../Inventories/InventoryItemViews";
import { Maintenance } from "../Maintenance/Maintenance";
import { Manage } from "../Manage/Manage";
import { Notebooks } from "../ELN/ELN";
import { PageNotFound } from "./common/PageNotFound/PageNotFound";
import { DataFormatsTablePage } from "../DataFormats/DataFormatViews";
import {
  PersonAddFormPage,
  PersonCloneFormPage,
  PersonDetailsPage,
  PersonEditFormPage,
  PersonsTablePage,
} from "../Persons/PersonViews";
import {
  ProjectAddFormPage,
  ProjectCloneFormPage,
  ProjectDetailsPage,
  ProjectEditFormPage,
  ProjectsTablePage,
} from "../Projects/ProjectViews";
import {
  RoleAddFormPage,
  RoleCloneFormPage,
  RoleDetailsPage,
  RoleEditFormPage,
  RolesTablePage,
} from "../Roles/RoleViews";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import {
  SampleAddFormPage,
  SampleCloneFormPage,
  SampleDetailsPage,
  SampleEditFormPage,
  SamplesTablePage,
} from "../samples/SampleViews";
import { SamplesBulkEditTable } from "../samples/Table/SamplesBulkEditTable";
import {
  SharedContentAddFormPage,
  SharedContentCloneFormPage,
  SharedContentDetailsPage,
  SharedContentEditFormPage,
  SharedContentsTablePage,
} from "../SharedBundles/SharedContentViews";
import { ApiKeyDataLayer } from "../ApiKeyManager/ApiKeyDataLayer";
import { EntitiesRedirect } from "../Entities/EntitiesRedirect";
import { EntitiesSearch } from "../Entities/EntitiesSearch";
import {
  getAddRoute,
  getBulkEditRoute,
  getCloneRoute,
  getDetailRoute,
  getEditRoute,
  getExportRoute,
  getIndexRoute,
  getUUIDRoute,
} from "./Routing";
import { useContext } from "react";
import { MethodDetailsPage, MethodsTablePage } from "../Methods/MethodViews";
import { DataFormatsSelectionTable } from "../DataFormats/DataFormatSelectionTable";
import { LegacyRouteRedirect, LegacyRouteViaAPI } from "./common/LegacyRouteRedirect/LegacyRouteRedirect";
import { AdminStatisticsTable } from "../Admin/AdminStatisticsTable";
import { MultiViewer } from "../Dataset/MultiViewer";
import { CustomTypeTemplatesTablePage } from "../Customization/CustomTypeTemplates/CustomTypeTemplateViews";
import {
  CustomTypeTemplatePackageDetailsPage,
  CustomTypeTemplatePackagesTablePage,
} from "../Customization/CustomTypeTemplatePackages/CustomTypeTemplatePackageViews";
import { CustomImportDetailsPage, CustomImportsTablePage } from "../CustomImports/CustomImportViews";
import {
  CustomImportLogDetailsPage,
  CustomImportLogsTablePage,
} from "../CustomImports/CustomImportLogs/CustomImportLogViews";
import { OidcRedirect } from "./LoginPage/OidcRedirect";
import { GenericEntityExportView } from "../Entities/GenericComponents/common/GenericEntityExportView";
import { FileExportJobDetailsPage, FileExportJobsTablePage } from "../FileExportJobs/FileExportJobViews";
import {
  CustomFieldTemplatesDetailsPage,
  CustomFieldTemplatesTablePage,
} from "../Customization/CustomFieldTemplates/CustomFieldTemplateViews";
import { TemplatesLandingPage } from "../Customization/CustomTypeTemplates/TemplatesLandingPage";
import { ZontalIntegrationLandingPage } from "../Integrations/ZONTAL/ZontalIntegrationLandingPage";
import {
  ZontalCredentialAddFormPage,
  ZontalCredentialEditFormPage,
} from "../Integrations/ZONTAL/Credentials/ZontalCredentialViews";
import { ZontalIPPDetailsPage, ZontalIPPTablePage } from "../Integrations/ZONTAL/IPP/ZontalIPPViews";

// import { SharedBundles } from "../SharedBundles/SharedBundles";
export const MainRouter = () => {
  const { route, api } = useContext(SessionContext);
  return <MainRoutingTable route={route} api={api} />;
};

// We embed all routes in LOGS even though only a part is used for each embedded page
// But the Conductance routing has priority there, so the other routes simply won't be hit
export const EmbeddedRouter = () => {
  const { route, api } = useContext(SessionContext);
  return <MainRoutingTable route={route} api={api} />;
};

export const MainRoutingTable = ({ route, api }: { route: (url: string) => string; api: API }) => {
  const location = useLocation();
  const history = useHistory();
  const isElnActivated = useFeatureFlag("eln");
  const isDevelopmentMode = useFeatureFlag("development_mode");

  // Legacy support for hash routing
  if (location.hash.startsWith("#")) {
    history.push(location.hash.replace("#", "")); // or history.replace
  }

  return (
    <>
      {/* Redirect routes */}
      <LegacyRouteRedirect
        from={"bundles"}
        to={genericEntityConstants.sharedContents.entityConstants.frontendIndexRoute}
      />

      <LegacyRouteRedirect from={"data"} to={genericEntityConstants.datasets.entityConstants.frontendIndexRoute} />

      <LegacyRouteViaAPI
        legacyRoute="documents"
        apiEntityType={"documents"}
        indexRoute={genericEntityConstants.inventories.entityConstants.frontendIndexRoute}
      />

      <LegacyRouteViaAPI
        legacyRoute="experiments"
        apiEntityType={"experiments"}
        indexRoute={genericEntityConstants.inventories.entityConstants.frontendIndexRoute}
      />

      <LegacyRouteViaAPI
        legacyRoute="organizations"
        apiEntityType={"organizations"}
        indexRoute={genericEntityConstants.inventories.entityConstants.frontendIndexRoute}
      />

      <LegacyRouteViaAPI
        legacyRoute="organization_tags"
        apiEntityType={"organizations"}
        indexRoute={genericEntityConstants.inventories.entityConstants.frontendIndexRoute}
      />

      <LegacyRouteViaAPI
        legacyRoute="project_tags"
        apiEntityType={"projectTags"}
        indexRoute={genericEntityConstants.inventories.entityConstants.frontendIndexRoute}
      />

      <LegacyRouteViaAPI
        legacyRoute="person_tags"
        apiEntityType={"personTags"}
        indexRoute={genericEntityConstants.inventories.entityConstants.frontendIndexRoute}
      />

      <LegacyRouteViaAPI
        legacyRoute="instruments"
        apiEntityType={"instruments"}
        indexRoute={genericEntityConstants.inventories.entityConstants.frontendIndexRoute}
      />

      {/* This doesn't work as we need a mapping from document_id to inventory_id */}
      {/* <LegacyRouteRedirect from={"documents"} to={inventoriesConstants.frontendIndexRoute} /> */}

      {/* Main routes */}
      <Switch>
        {/* Dashboard */}
        <Route path={route(getIndexRoute("dashboard"))} exact>
          <Dashboard />
        </Route>

        {/* SSO redirect handler */}
        <Route path={route("/oidc_redirect")}>
          <OidcRedirect />
        </Route>

        {/* Parser selection */}
        <Route path={route(getIndexRoute("parser_selections"))} exact>
          <Manage>
            {/* Permission check is done in the table */}
            <DataFormatsSelectionTable />
          </Manage>
        </Route>

        {/* About */}
        <Route path={route(getIndexRoute("about"))} exact>
          <About />
        </Route>

        {/* Admin */}
        <Route path={route(getIndexRoute("admin"))} exact>
          <Manage>
            <AdminStatisticsTable />
          </Manage>
        </Route>

        {/* Announcements */}
        <Route
          path={route(getIndexRoute(genericEntityConstants.announcements.entityConstants.frontendIndexRoute))}
          exact
        >
          <Manage>
            <AnnouncementsTablePage />
          </Manage>
        </Route>
        <Route path={route(getAddRoute(genericEntityConstants.announcements.entityConstants.frontendIndexRoute))}>
          <Manage>
            <AnnouncementAddFormPage />
          </Manage>
        </Route>
        <Route path={route(getEditRoute(genericEntityConstants.announcements.entityConstants.frontendIndexRoute))}>
          <Manage>
            <AnnouncementEditFormPage />
          </Manage>
        </Route>
        <Route path={route(getCloneRoute(genericEntityConstants.announcements.entityConstants.frontendIndexRoute))}>
          <Manage>
            <AnnouncementCloneFormPage />
          </Manage>
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.announcements.entityConstants.frontendIndexRoute))}>
          <Manage>
            <AnnouncementDetailsPage />
          </Manage>
        </Route>

        {/* Apikey */}
        <Route path={route(getIndexRoute(genericEntityConstants.apiKeys.entityConstants.frontendIndexRoute))} exact>
          <Manage>
            <ApiKeyDataLayer api={api} />
          </Manage>
        </Route>

        {/* Attachments */}
        <Route path={route(getIndexRoute(genericEntityConstants.attachments.entityConstants.frontendIndexRoute))} exact>
          <Manage>
            <AttachmentsTablePage />
          </Manage>
        </Route>
        <Route path={route(getEditRoute(genericEntityConstants.attachments.entityConstants.frontendIndexRoute))}>
          <Manage>
            <AttachmentEditFormPage />
          </Manage>
        </Route>
        <Route
          path={route(getExportRoute(genericEntityConstants.attachments.entityConstants.frontendIndexRoute))}
          exact
        >
          <GenericEntityExportView entityTypeId="attachments" />
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.attachments.entityConstants.frontendIndexRoute))}>
          <Manage>
            <AttachmentDetailsPage />
          </Manage>
        </Route>

        {/* Auditlog */}
        <Route path={route(getIndexRoute(genericEntityConstants.auditLogs.entityConstants.frontendIndexRoute))} exact>
          <Manage>
            <AuditLogsTablePage />
          </Manage>
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.auditLogs.entityConstants.frontendIndexRoute))}>
          <Manage>
            <AuditLogDetailsPage />
          </Manage>
        </Route>

        {/* Autoloads -> Bridges (former "sources") */}
        <Route path={route(getIndexRoute(genericEntityConstants.bridges.entityConstants.frontendIndexRoute))} exact>
          <Manage>
            <BridgesTablePage />
          </Manage>
        </Route>
        <Route path={route(getAddRoute(genericEntityConstants.bridges.entityConstants.frontendIndexRoute))}>
          <Manage>
            <BridgeClientWizard />
          </Manage>
        </Route>
        <Route
          path={route(
            `${getIndexRoute(genericEntityConstants.bridges.entityConstants.frontendIndexRoute)}/sftp_wizard`
          )}
        >
          <Manage>
            <SFTPBridgeClientWizard />
          </Manage>
        </Route>
        <Route path={route(getEditRoute(genericEntityConstants.bridges.entityConstants.frontendIndexRoute))}>
          <Manage>
            <BridgeEditFormPage />
          </Manage>
        </Route>
        <Route path={route(getCloneRoute(genericEntityConstants.bridges.entityConstants.frontendIndexRoute))}>
          <Manage>
            <BridgeCloneFormPage />
          </Manage>
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.bridges.entityConstants.frontendIndexRoute))} exact>
          <Manage>
            <BridgeDetailsPage />
          </Manage>
        </Route>

        {/* Autoloads -> Data sources (former configurations) */}
        <Route path={route(getIndexRoute(genericEntityConstants.dataSources.entityConstants.frontendIndexRoute))} exact>
          <Manage>
            <DataSourceTablePage />
          </Manage>
        </Route>
        <Route path={route(getAddRoute(genericEntityConstants.dataSources.entityConstants.frontendIndexRoute))}>
          <Manage>
            <DataSourceAddFormPage />
          </Manage>
        </Route>
        <Route path={route(getEditRoute(genericEntityConstants.dataSources.entityConstants.frontendIndexRoute))}>
          <Manage>
            <DataSourceEditFormPage />
          </Manage>
        </Route>
        <Route path={route(getCloneRoute(genericEntityConstants.dataSources.entityConstants.frontendIndexRoute))}>
          <Manage>
            <DataSourceCloneFormPage />
          </Manage>
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.dataSources.entityConstants.frontendIndexRoute))}>
          <Manage>
            <DataSourceDetailsPage />
          </Manage>
        </Route>
        <Route
          path={route(
            `${getIndexRoute(bridgeConstants.frontendIndexRoute)}/:bridgeId${getAddRoute(
              genericEntityConstants.dataSources.entityConstants.frontendIndexRoute
            )}`
          )}
        >
          <Manage>
            <DataSourceAddFormPage />
          </Manage>
        </Route>
        <Route
          path={route(
            `${getIndexRoute(bridgeConstants.frontendIndexRoute)}/:bridgeId${getEditRoute(
              genericEntityConstants.dataSources.entityConstants.frontendIndexRoute
            )}`
          )}
        >
          <Manage>
            <DataSourceEditFormPage />
          </Manage>
        </Route>
        <Route
          path={route(
            `${getIndexRoute(bridgeConstants.frontendIndexRoute)}/:bridgeId${getCloneRoute(
              genericEntityConstants.dataSources.entityConstants.frontendIndexRoute
            )}`
          )}
        >
          <Manage>
            <DataSourceCloneFormPage />
          </Manage>
        </Route>
        <Route
          path={route(
            `${getIndexRoute(bridgeConstants.frontendIndexRoute)}/:bridgeId${getDetailRoute(
              genericEntityConstants.dataSources.entityConstants.frontendIndexRoute
            )}`
          )}
        >
          <Manage>
            <DataSourceDetailsPage />
          </Manage>
        </Route>

        {/* Custom Fields */}
        <Route
          path={route(getIndexRoute(genericEntityConstants.customFields.entityConstants.frontendIndexRoute))}
          exact
        >
          <Manage>
            <CustomFieldsTablePage />
          </Manage>
        </Route>
        <Route path={route(getAddRoute(genericEntityConstants.customFields.entityConstants.frontendIndexRoute))}>
          <Manage>
            <CustomFieldAddFormPage />
          </Manage>
        </Route>
        <Route path={route(getEditRoute(genericEntityConstants.customFields.entityConstants.frontendIndexRoute))}>
          <Manage>
            <CustomFieldEditFormPage />
          </Manage>
        </Route>
        <Route path={route(getCloneRoute(genericEntityConstants.customFields.entityConstants.frontendIndexRoute))}>
          <Manage>
            <CustomFieldCloneFormPage />
          </Manage>
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.customFields.entityConstants.frontendIndexRoute))}>
          <Manage>
            <CustomFieldDetailsPage />
          </Manage>
        </Route>

        {/* Custom Types */}
        <Route path={route(getIndexRoute(genericEntityConstants.customTypes.entityConstants.frontendIndexRoute))} exact>
          <Manage>
            <CustomTypesTablePage />
          </Manage>
        </Route>
        <Route path={route(getAddRoute(genericEntityConstants.customTypes.entityConstants.frontendIndexRoute))}>
          <Manage>
            <CustomTypeAddFormPage />
          </Manage>
        </Route>
        <Route path={route(getEditRoute(genericEntityConstants.customTypes.entityConstants.frontendIndexRoute))}>
          <Manage>
            <CustomTypeEditFormPage />
          </Manage>
        </Route>
        <Route path={route(getCloneRoute(genericEntityConstants.customTypes.entityConstants.frontendIndexRoute))}>
          <Manage>
            <CustomTypeCloneFormPage />
          </Manage>
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.customTypes.entityConstants.frontendIndexRoute))}>
          <Manage>
            <CustomTypeDetailsPage />
          </Manage>
        </Route>

        {/* Template landing page */}
        <Route path={route(getIndexRoute("templates"))} exact>
          <Manage>
            <TemplatesLandingPage />
          </Manage>
        </Route>
        {/* Custom Type Templates */}
        <Route
          path={route(getIndexRoute(genericEntityConstants.customTypeTemplates.entityConstants.frontendIndexRoute))}
          exact
        >
          <Manage>
            <CustomTypeTemplatesTablePage />
          </Manage>
        </Route>
        {/* Custom Field Templates */}
        <Route
          path={route(getIndexRoute(genericEntityConstants.customFieldTemplates.entityConstants.frontendIndexRoute))}
          exact
        >
          <Manage>
            <CustomFieldTemplatesTablePage />
          </Manage>
        </Route>
        <Route
          path={route(getDetailRoute(genericEntityConstants.customFieldTemplates.entityConstants.frontendIndexRoute))}
          exact
        >
          <Manage>
            <CustomFieldTemplatesDetailsPage />
          </Manage>
        </Route>
        {/* Custom Type Template Packages */}
        <Route
          path={route(
            getIndexRoute(genericEntityConstants.customTypeTemplatePackages.entityConstants.frontendIndexRoute)
          )}
          exact
        >
          <Manage>
            <CustomTypeTemplatePackagesTablePage />
          </Manage>
        </Route>
        <Route
          path={route(
            getDetailRoute(genericEntityConstants.customTypeTemplatePackages.entityConstants.frontendIndexRoute)
          )}
          exact
        >
          <Manage>
            <CustomTypeTemplatePackageDetailsPage />
          </Manage>
        </Route>

        {/* Datasets */}
        <Route path={route(getIndexRoute(genericEntityConstants.datasets.entityConstants.frontendIndexRoute))} exact>
          <DatasetsTablePage />
        </Route>
        {/* Multiple dataset viewer */}
        <Route path={route(`${getIndexRoute("datasets")}/overlay`)} exact>
          <MultiViewer />
        </Route>
        <Route path={route(getAddRoute(genericEntityConstants.datasets.entityConstants.frontendIndexRoute))}>
          <DatasetAddForm />
        </Route>
        <Route path={route(getBulkEditRoute(genericEntityConstants.datasets.entityConstants.frontendIndexRoute))}>
          <DatasetsBulkEditTable />
        </Route>
        <Route path={route(getEditRoute(genericEntityConstants.datasets.entityConstants.frontendIndexRoute))}>
          <DatasetEditFormPage />
        </Route>
        <Route
          path={route(`${getIndexRoute(genericEntityConstants.datasets.entityConstants.frontendIndexRoute)}/:id/claim`)}
        >
          <DatasetClaimFormPage />
        </Route>
        <Route
          path={route(
            `${getIndexRoute(genericEntityConstants.datasets.entityConstants.frontendIndexRoute)}/:id/viewer`
          )}
        >
          <DatasetDetailsPage viewViewer={true} />
        </Route>
        <Route path={route(getExportRoute(genericEntityConstants.datasets.entityConstants.frontendIndexRoute))} exact>
          <GenericEntityExportView entityTypeId="datasets" />
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.datasets.entityConstants.frontendIndexRoute))}>
          <DatasetDetailsPage />
        </Route>

        {/* Dataset formats */}
        <Route path={route(getIndexRoute(genericEntityConstants.dataFormats.entityConstants.frontendIndexRoute))} exact>
          <Manage>
            <DataFormatsTablePage />
          </Manage>
        </Route>

        {/* IconNMR */}
        <Route path={route(getIndexRoute(iconNMRConstants.frontendIndexRoute))} exact>
          <Manage>
            <IconNMR />
          </Manage>
        </Route>
        <Route path={`${route(getIndexRoute(iconNMRConstants.frontendIndexRoute))}/overview`} exact>
          <Manage>
            <IconNMR />
          </Manage>
        </Route>
        <Route path={`${route(getIndexRoute(iconNMRConstants.frontendIndexRoute))}/queue`} exact>
          <Manage>
            <IconNMR />
          </Manage>
        </Route>
        <Route path={`${route(getIndexRoute(iconNMRConstants.frontendIndexRoute))}/history`} exact>
          <Manage>
            <IconNMR />
          </Manage>
        </Route>
        <Route path={route(getAddRoute(iconNMRConstants.frontendIndexRoute))}>
          <Manage>
            <IconNMRDataSourceAddFormPage />
          </Manage>
        </Route>
        <Route path={route(getEditRoute(iconNMRConstants.frontendIndexRoute))}>
          <Manage>
            <IconNMRDataSourceEditFormPage />
          </Manage>
        </Route>
        <Route path={route(getCloneRoute(iconNMRConstants.frontendIndexRoute))}>
          <Manage>
            <IconNMRDataSourceCloneFormPage />
          </Manage>
        </Route>
        <Route path={route(getDetailRoute(iconNMRConstants.frontendIndexRoute))}>
          <Manage>
            <IconNMRDataSourceDetailsPage />
          </Manage>
        </Route>

        {/* Inventories */}
        <Route path={route(getIndexRoute(genericEntityConstants.inventories.entityConstants.frontendIndexRoute))} exact>
          <InventoriesTablePage />
        </Route>
        <Route
          path={`${route(
            getIndexRoute(genericEntityConstants.inventories.entityConstants.frontendIndexRoute)
          )}/:customTypeId/hierarchy`}
          exact
        >
          <InventoryItemTreePage />
        </Route>
        <Route
          path={`${route(
            getIndexRoute(genericEntityConstants.inventories.entityConstants.frontendIndexRoute)
          )}/:customTypeId/hierarchy/:id`}
        >
          <InventoryItemTreePage />
        </Route>
        <Route
          path={`${route(
            getIndexRoute(genericEntityConstants.inventories.entityConstants.frontendIndexRoute)
          )}/:customTypeId/items`}
          exact
        >
          <InventoryItemsTablePage />
        </Route>
        <Route
          path={route(getIndexRoute(genericEntityConstants.inventoryItems.entityConstants.frontendIndexRoute))}
          exact
        >
          <InventoryItemsTablePage />
        </Route>
        <Route
          path={`${route(
            getIndexRoute(genericEntityConstants.inventories.entityConstants.frontendIndexRoute)
          )}/:customTypeId/items/new`}
        >
          <InventoryItemAddFormPage />
        </Route>
        <Route path={route(getAddRoute(genericEntityConstants.inventoryItems.entityConstants.frontendIndexRoute))}>
          <InventoryItemAddFormPage />
        </Route>
        <Route
          path={`${route(
            getIndexRoute(genericEntityConstants.inventories.entityConstants.frontendIndexRoute)
          )}/:customTypeId/items/:id/edit`}
        >
          <InventoryItemEditFormPage />
        </Route>
        <Route path={route(getEditRoute(genericEntityConstants.inventoryItems.entityConstants.frontendIndexRoute))}>
          <InventoryItemEditFormPage />
        </Route>
        <Route
          path={`${route(
            getIndexRoute(genericEntityConstants.inventories.entityConstants.frontendIndexRoute)
          )}/:customTypeId/items/:id/clone`}
        >
          <InventoryItemCloneFormPage />
        </Route>
        <Route path={route(getCloneRoute(genericEntityConstants.inventoryItems.entityConstants.frontendIndexRoute))}>
          <InventoryItemCloneFormPage />
        </Route>
        <Route
          path={route(getExportRoute(genericEntityConstants.inventoryItems.entityConstants.frontendIndexRoute))}
          exact
        >
          <GenericEntityExportView entityTypeId="inventoryItems" />
        </Route>
        <Route
          path={`${route(
            getIndexRoute(genericEntityConstants.inventories.entityConstants.frontendIndexRoute)
          )}/:customTypeId/items/:id`}
        >
          <InventoryItemDetailsPage />
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.inventoryItems.entityConstants.frontendIndexRoute))}>
          <InventoryItemDetailsPage />
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.inventories.entityConstants.frontendIndexRoute))}>
          <InventoryDetailsRedirect />
        </Route>

        {/* Maintenance */}
        <Route path={route(getIndexRoute("maintenance"))} exact>
          <Manage>
            {/* Permission check is done in the table */}
            <Maintenance />
          </Manage>
        </Route>

        {/* Manage */}
        <Route path={route(getIndexRoute("manage"))} exact>
          <Manage />
        </Route>

        {/* Methods */}
        <Route path={route(getIndexRoute(genericEntityConstants.methods.entityConstants.frontendIndexRoute))} exact>
          <Manage>
            <MethodsTablePage />
          </Manage>
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.methods.entityConstants.frontendIndexRoute))}>
          <Manage>
            <MethodDetailsPage />
          </Manage>
        </Route>

        {/* Notebooks */}
        {isElnActivated && (
          <Route path={route(getIndexRoute(genericEntityConstants.notebooks.entityConstants.frontendIndexRoute))}>
            <Notebooks />
          </Route>
        )}

        {/* Persons */}
        <Route path={route(getIndexRoute(genericEntityConstants.persons.entityConstants.frontendIndexRoute))} exact>
          <Manage>
            <PersonsTablePage />
          </Manage>
        </Route>
        <Route path={route(getAddRoute(genericEntityConstants.persons.entityConstants.frontendIndexRoute))}>
          <Manage>
            <PersonAddFormPage />
          </Manage>
        </Route>
        <Route path={route(getEditRoute(genericEntityConstants.persons.entityConstants.frontendIndexRoute))}>
          <Manage>
            <PersonEditFormPage />
          </Manage>
        </Route>
        <Route path={route(getCloneRoute(genericEntityConstants.persons.entityConstants.frontendIndexRoute))}>
          <Manage>
            <PersonCloneFormPage />
          </Manage>
        </Route>
        <Route path={route(getExportRoute(genericEntityConstants.persons.entityConstants.frontendIndexRoute))} exact>
          <GenericEntityExportView entityTypeId="persons" />
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.persons.entityConstants.frontendIndexRoute))}>
          <Manage>
            <PersonDetailsPage />
          </Manage>
        </Route>

        {/* Projects */}
        <Route path={route(getIndexRoute(genericEntityConstants.projects.entityConstants.frontendIndexRoute))} exact>
          <ProjectsTablePage />
        </Route>
        <Route path={route(getAddRoute(genericEntityConstants.projects.entityConstants.frontendIndexRoute))}>
          <ProjectAddFormPage />
        </Route>
        <Route path={route(getEditRoute(genericEntityConstants.projects.entityConstants.frontendIndexRoute))}>
          <ProjectEditFormPage />
        </Route>
        <Route path={route(getCloneRoute(genericEntityConstants.projects.entityConstants.frontendIndexRoute))}>
          <ProjectCloneFormPage />
        </Route>
        <Route path={route(getExportRoute(genericEntityConstants.projects.entityConstants.frontendIndexRoute))} exact>
          <GenericEntityExportView entityTypeId="projects" />
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.projects.entityConstants.frontendIndexRoute))}>
          <ProjectDetailsPage />
        </Route>

        {/* Roles */}
        <Route path={route(getIndexRoute(genericEntityConstants.roles.entityConstants.frontendIndexRoute))} exact>
          <Manage>
            <RolesTablePage />
          </Manage>
        </Route>
        <Route path={route(getAddRoute(genericEntityConstants.roles.entityConstants.frontendIndexRoute))}>
          <Manage>
            <RoleAddFormPage />
          </Manage>
        </Route>
        <Route path={route(getEditRoute(genericEntityConstants.roles.entityConstants.frontendIndexRoute))}>
          <Manage>
            <RoleEditFormPage />
          </Manage>
        </Route>
        <Route path={route(getCloneRoute(genericEntityConstants.roles.entityConstants.frontendIndexRoute))}>
          <Manage>
            <RoleCloneFormPage />
          </Manage>
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.roles.entityConstants.frontendIndexRoute))}>
          <Manage>
            <RoleDetailsPage />
          </Manage>
        </Route>

        {/* Samples */}
        <Route path={route(getIndexRoute(genericEntityConstants.samples.entityConstants.frontendIndexRoute))} exact>
          <SamplesTablePage />
        </Route>
        <Route path={route(getBulkEditRoute(genericEntityConstants.samples.entityConstants.frontendIndexRoute))}>
          <SamplesBulkEditTable />
        </Route>
        <Route path={route(getAddRoute(genericEntityConstants.samples.entityConstants.frontendIndexRoute))}>
          <SampleAddFormPage />
        </Route>
        <Route path={route(getEditRoute(genericEntityConstants.samples.entityConstants.frontendIndexRoute))}>
          <SampleEditFormPage />
        </Route>
        <Route path={route(getCloneRoute(genericEntityConstants.samples.entityConstants.frontendIndexRoute))}>
          <SampleCloneFormPage />
        </Route>
        <Route path={route(getExportRoute(genericEntityConstants.samples.entityConstants.frontendIndexRoute))} exact>
          <GenericEntityExportView entityTypeId="samples" />
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.samples.entityConstants.frontendIndexRoute))}>
          <SampleDetailsPage />
        </Route>

        {/* Shared content */}

        <Route
          path={route(getIndexRoute(genericEntityConstants.sharedContents.entityConstants.frontendIndexRoute))}
          exact
        >
          <Manage>
            <SharedContentsTablePage />
          </Manage>
        </Route>
        <Route path={route(getAddRoute(genericEntityConstants.sharedContents.entityConstants.frontendIndexRoute))}>
          <Manage>
            <SharedContentAddFormPage />
          </Manage>
        </Route>
        <Route path={route(getEditRoute(genericEntityConstants.sharedContents.entityConstants.frontendIndexRoute))}>
          <Manage>
            <SharedContentEditFormPage />
          </Manage>
        </Route>
        <Route path={route(getCloneRoute(genericEntityConstants.sharedContents.entityConstants.frontendIndexRoute))}>
          <Manage>
            <SharedContentCloneFormPage />
          </Manage>
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.sharedContents.entityConstants.frontendIndexRoute))}>
          <Manage>
            <SharedContentDetailsPage />
          </Manage>
        </Route>

        {/* File export jobs */}
        <Route
          path={route(getIndexRoute(genericEntityConstants.fileExportJobs.entityConstants.frontendIndexRoute))}
          exact
        >
          <Manage>
            <FileExportJobsTablePage />
          </Manage>
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.fileExportJobs.entityConstants.frontendIndexRoute))}>
          <Manage>
            <FileExportJobDetailsPage />
          </Manage>
        </Route>

        {/* Custom imports */}
        <Route
          path={route(getIndexRoute(genericEntityConstants.customImports.entityConstants.frontendIndexRoute))}
          exact
        >
          <Manage>
            <CustomImportsTablePage />
          </Manage>
        </Route>
        {/* <Route path={route(getAddRoute(genericEntityConstants.customImports.entityConstants.frontendIndexRoute))}>
          <CustomImportAddFormPage />
        </Route>
        <Route path={route(getEditRoute(genericEntityConstants.customImports.entityConstants.frontendIndexRoute))}>
          <CustomImportEditFormPage />
        </Route>
        <Route path={route(getCloneRoute(genericEntityConstants.customImports.entityConstants.frontendIndexRoute))}>
          <CustomImportCloneFormPage />
        </Route> */}
        <Route path={route(getDetailRoute(genericEntityConstants.customImports.entityConstants.frontendIndexRoute))}>
          <Manage>
            <CustomImportDetailsPage />
          </Manage>
        </Route>

        {/* Custom import logs */}
        <Route
          path={route(getIndexRoute(genericEntityConstants.customImportLogs.entityConstants.frontendIndexRoute))}
          exact
        >
          <CustomImportLogsTablePage />
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.customImportLogs.entityConstants.frontendIndexRoute))}>
          <CustomImportLogDetailsPage />
        </Route>

        {/* UUID */}
        <Route path={route(getIndexRoute("uuid"))} exact>
          <Manage>
            <EntitiesSearch />
          </Manage>
        </Route>
        <Route path={route(getUUIDRoute("uuid"))}>
          <EntitiesRedirect />
        </Route>

        {/* ZONTAL integration */}
        {/* Zontal Credentials */}
        <Route
          path={route(getIndexRoute(genericEntityConstants.zontalCredentials.entityConstants.frontendIndexRoute))}
          exact
        >
          <Manage>
            <ZontalIntegrationLandingPage />
          </Manage>
        </Route>

        <Route path={route(getAddRoute(genericEntityConstants.zontalCredentials.entityConstants.frontendIndexRoute))}>
          <Manage>
            <ZontalCredentialAddFormPage />
          </Manage>
        </Route>
        <Route path={route(getEditRoute(genericEntityConstants.zontalCredentials.entityConstants.frontendIndexRoute))}>
          <Manage>
            <ZontalCredentialEditFormPage />
          </Manage>
        </Route>
        {/* Zontal IPP */}

        <Route path={route(getIndexRoute(genericEntityConstants.zontalIPP.entityConstants.frontendIndexRoute))} exact>
          <Manage>
            <ZontalIPPTablePage />
          </Manage>
        </Route>
        <Route path={route(getDetailRoute(genericEntityConstants.zontalIPP.entityConstants.frontendIndexRoute))}>
          <Manage>
            <ZontalIPPDetailsPage />
          </Manage>
        </Route>

        {/* Devel only routes */}
        {isDevelopmentMode && (
          <Route path={route(getIndexRoute("components"))} exact>
            <ComponentOverview api={api} />
          </Route>
        )}

        {/* Page not found */}
        <Route path="/:group/*">
          <PageNotFound />
        </Route>
      </Switch>
    </>
  );
};
